import { useCallback, useEffect, useState } from "react";

export const formatTimer = (seconds) => {
  const mm = String(Math.floor(seconds / 60)).padStart(2, "0");
  const ss = String(seconds % 60).padStart(2, "0");
  return `${mm}:${ss}`;
};

export const PASSWORD_RULES = [
  { key: "length", label: "8+ characters", test: (pwd) => pwd.length >= 8 },
  {
    key: "case",
    label: "Upper & lower case",
    test: (pwd) => /[a-z]/.test(pwd) && /[A-Z]/.test(pwd),
  },
  { key: "number", label: "At least 1 number", test: (pwd) => /\d/.test(pwd) },
  {
    key: "special",
    label: "A special character",
    test: (pwd) => /[^A-Za-z0-9]/.test(pwd),
  },
];

export const useCountdown = (initialSeconds) => {
  const [remaining, setRemaining] = useState(initialSeconds);

  useEffect(() => {
    if (remaining <= 0) return undefined;
    const id = setTimeout(() => setRemaining((prev) => prev - 1), 1000);
    return () => clearTimeout(id);
  }, [remaining]);

  const restart = useCallback(
    (seconds = initialSeconds) => setRemaining(seconds),
    [initialSeconds],
  );

  return [remaining, restart];
};
